import { useState, useEffect } from 'react'
import EkomApi from '../api/EkomApi'
import { iMsg, iSubm } from '../types/msg.types'
import { useTableContextParams } from '../context/TableContext'

export const useSubmissionsList = (extSystemId?: string, extObjectId?: string) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [data, setData] = useState<iSubm[]>([])
  const [totalCount, setTotalCount] = useState<number>()

  const params = useTableContextParams()

  useEffect(() => {
    fetchData()
  }, [params])

  const fetchData = async () => {
    setError('')
    setLoading(true)
    try {
      if (extSystemId) {
        params.systemExtId = extSystemId
      }
      if (extObjectId) {
        params.objectExtId = extObjectId
      }

      const result =  await EkomApi.getSubmissionsSearch(params)
      const subs = result.data.map((msg) => ({
        ...msg.submission
      }))
      setData(subs)
      setTotalCount(result.totalCount)
    } catch (error: any) {
      setError('Nepodařilo se získat data.')
    } finally {
      setLoading(false)
    }
  }

  return { loading, error, data, totalCount }
}
